import { motion, useReducedMotion } from 'motion/react'
import { fastSpatial, reducedFade } from '../motion/tokens'
import { Symbol, type SymbolName } from './Symbol'

/**
 * Die eine Haupthandlung einer Seite.
 *
 * Schmal zeigt er nur das Zeichen und trägt den Namen für die Sprachausgabe;
 * `breit` stellt den Namen daneben. Beim Erscheinen federt er einmal auf —
 * das ist die Signaturbewegung von Material 3 Expressive und der Grund, warum
 * er überhaupt auffällt.
 */
export function Fab({
  icon,
  label,
  breit = false,
  onClick,
}: {
  icon: SymbolName
  label: string
  breit?: boolean
  onClick?: () => void
}) {
  const ruhig = useReducedMotion()
  return (
    <motion.button
      type="button"
      className={`fab${breit ? ' fab--breit' : ''}`}
      aria-label={label}
      onClick={onClick}
      initial={ruhig ? { opacity: 0 } : { opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      // ⚠️ Ohne `exit` hat `AnimatePresence` nichts abzuspielen und entfernt
      // den Knopf sofort: Auftritt gefedert, Abgang in EINEM Bild (gemessen:
      // 0 Bilder mit Teil-Deckkraft). Genau diese Asymmetrie fällt als
      // „abgehackt" auf. Der Abgang ist knapper als der Auftritt - etwas, das
      // geht, soll nicht um Aufmerksamkeit bitten.
      exit={ruhig ? { opacity: 0 } : { opacity: 0, scale: 0.8 }}
      transition={ruhig ? reducedFade : fastSpatial}
    >
      <Symbol name={icon} />
      {breit ? <span className="fab__text">{label}</span> : null}
    </motion.button>
  )
}
